module.exports = __webpack_public_path__ + "static/media/appStoreEs.bb68a84c.svg";